module.exports = __webpack_public_path__ + "static/media/background_maintainance.1b904e2f.svg";